<template>
    <div class="flex column code-box">
        <van-icon name="info" size=".5rem" class="color-primary"/>
        <div class="code-text">口令验证</div>
        <div class="passcode-display">
            <div class="passcode-value">{{ passcode }}</div>
        </div>
        <div class="mt-2 fs-12 color-primary">
          请在人脸验证app上输入上方口令完成验证
        </div>
    </div>
</template>

<script>
export default {
    name: "PasscodeVerify"
}
</script>

<script setup>
import { defineProps } from 'vue'


const props = defineProps({
    passcode: {
        type: String,
        default: ''
    },
});


</script>

<style lang="scss" scoped>
.code-box {
  margin-top: 15px;
  padding: 0 15px;

  .code-text {
    margin-top: 5px;
    font-weight: bold;
  }

  .passcode-display {
    margin-top: 10px;
    width: 100%;
    height: 45px;
    background-color: #f5f5f5;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .passcode-value {
      font-size: 24px;
      font-weight: bold;
      color: #08AFFF;
      letter-spacing: 2px;
    }
  }
}

.reflesh {
  padding: 6px 35px;
  font-size: 14px;
  font-weight: 500;
  color: #08AFFF;
  border-radius: 2px;
  border: 1px solid #08AFFF;
}
</style>
